import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import de from './locales/de.json';
import en from './locales/en.json';
import tr from './locales/tr.json';
import ar from './locales/ar.json';
import prs from './locales/prs.json';
import ps from './locales/ps.json';
import ur from './locales/ur.json';
import uk from './locales/uk.json';
import hi from './locales/hi.json';
import fa from './locales/fa.json';
import ro from './locales/ro.json';
import pl from './locales/pl.json';
import ru from './locales/ru.json';
import bg from './locales/bg.json';
import es from './locales/es.json';
import pt from './locales/pt.json';

const RTL_LANGUAGES = ['ar', 'prs', 'ps', 'ur', 'fa'];
const LANG_STORAGE_KEY = 'fahryo_language';
const savedLang = typeof window !== 'undefined'
  ? localStorage.getItem(LANG_STORAGE_KEY) : null;

i18n
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: de },
      en: { translation: en },
      tr: { translation: tr },
      ar: { translation: ar },
      prs: { translation: prs },
      ps: { translation: ps },
      ur: { translation: ur },
      uk: { translation: uk },
      hi: { translation: hi },
      fa: { translation: fa },
      ro: { translation: ro },
      pl: { translation: pl },
      ru: { translation: ru },
      bg: { translation: bg },
      es: { translation: es },
      pt: { translation: pt },
    },
    lng: savedLang || "de",
    fallbackLng: "de",
    interpolation: {
      escapeValue: false
    }
  });

// Save language to localStorage and update document direction
i18n.on('languageChanged', (lng: string) => {
  localStorage.setItem(LANG_STORAGE_KEY, lng);
  document.documentElement.dir = RTL_LANGUAGES.includes(lng) ? 'rtl' : 'ltr';
  document.documentElement.lang = lng;
});

export default i18n;
